export function localiseURL(url: string, locale: string): string {
  if (locale === 'en-US' || !locale || !url.startsWith('/') || url.startsWith(`/${locale}/`)) {
    return url
  }
  return '/' + locale + url
}
